"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgSignInScreen = void 0;
const Text_1 = __importDefault(require("@targetx/mineral-ui/Text"));
const AuthButton_1 = __importDefault(require("@targetx/tx-web-ui-lib/lib/components/AuthButton"));
const Layout_1 = __importDefault(require("@targetx/tx-web-ui-lib/lib/components/Layout"));
const react_1 = __importStar(require("react"));
const constants_1 = require("../../constants");
const paths_1 = __importDefault(require("../../constants/paths"));
const theme_1 = __importDefault(require("../../theme"));
const OrgBannerComponent_1 = __importDefault(require("../components/OrgBannerComponent"));
const OrgDeactivatedNotice_1 = __importDefault(require("../components/OrgDeactivatedNotice"));
const SignInForm_1 = __importDefault(require("../components/SignInForm"));
const DefaultScreenLayout_1 = __importDefault(require("../layouts/DefaultScreenLayout"));
const OrgSignInScreen_copyText_1 = __importDefault(require("./OrgSignInScreen.copyText"));
const ERROR_ORG_DEACTIVATED = 'ERROR_ORG_DEACTIVATED';
function OrgSignInScreen({ csrfToken, errorMessageKey, org }) {
    const initialState = {
        showSignInForm: false
    };
    const [state, setState] = (0, react_1.useState)(initialState);
    const { showSignInForm } = state;
    const handleClickShowSignInForm = () => {
        setState({ showSignInForm: true });
    };
    if (errorMessageKey === ERROR_ORG_DEACTIVATED) {
        return (react_1.default.createElement(DefaultScreenLayout_1.default, null,
            react_1.default.createElement(OrgDeactivatedNotice_1.default, null)));
    }
    if (errorMessageKey || showSignInForm || !org.salesforceID) {
        return (react_1.default.createElement(DefaultScreenLayout_1.default, null,
            react_1.default.createElement(SignInForm_1.default, { action: paths_1.default.postSignIn, csrfToken: csrfToken, errorMessageKey: errorMessageKey, org: org, resetPasswordPath: paths_1.default.orgPasswordReset.replace(':orgSID', org.sid) })));
    }
    return (react_1.default.createElement(DefaultScreenLayout_1.default, null,
        react_1.default.createElement(Layout_1.default, { width: "100%" },
            react_1.default.createElement(Layout_1.default.Header, null,
                react_1.default.createElement(Text_1.default, { as: "h1", fontSize: "1.5rem", fontWeight: "semiBold", marginTop: theme_1.default.space_stack_lg }, OrgSignInScreen_copyText_1.default.title)),
            react_1.default.createElement(Layout_1.default.Body, { marginTop: theme_1.default.space_stack_lg, paddingHorizontal: theme_1.default.space_inline_xxs, scrollable: true },
                react_1.default.createElement(OrgBannerComponent_1.default, { org: org }),
                react_1.default.createElement(AuthButton_1.default, { fullWidth: true, marginBottom: theme_1.default.space_stack_md, onClick: handleClickShowSignInForm }),
                react_1.default.createElement(AuthButton_1.default, { href: `${paths_1.default.authProviderSignIn.replace(':providerSID', constants_1.AUTH_PROVIDER_SALESFORCE)}`, fullWidth: true, provider: constants_1.AUTH_PROVIDER_SALESFORCE })))));
}
exports.OrgSignInScreen = OrgSignInScreen;
OrgSignInScreen.copyText = OrgSignInScreen_copyText_1.default;
OrgSignInScreen.ERROR_INVALID_CREDENTIALS =
    SignInForm_1.default.ERROR_INVALID_CREDENTIALS;
OrgSignInScreen.ERROR_ORG_DEACTIVATED = ERROR_ORG_DEACTIVATED;
OrgSignInScreen.ERROR_UNEXPECTED = SignInForm_1.default.ERROR_UNEXPECTED;
OrgSignInScreen.ERROR_USER_DEACTIVATED = SignInForm_1.default.ERROR_USER_DEACTIVATED;
exports.default = OrgSignInScreen;
